import { configureWithRelationshipSerializer, configurePaginatedSerializer } from './utils';

const ArticleWithRelationshipsSerializer = configureWithRelationshipSerializer({
  includeForeignModelAttrs: {
    modifiedBy: ['name'],
    publishedBy: ['name'],
    createdBy: ['name'],
    event: ['name'],
  },
});

const PaginatedArticleSerializer = configurePaginatedSerializer({ baseSerializer: ArticleWithRelationshipsSerializer });

export default {
  article: ArticleWithRelationshipsSerializer,
  paginatedArticles: PaginatedArticleSerializer,
};
